export const CREATE_PAGE_REQUEST = "CREATE_PAGE_REQUEST"
export const GET_PAGE_REQUEST = "GET_PAGE_REQUEST"
export const GET_PAGE_REQUEST_SUCCESS = "GET_PAGE_REQUEST_SUCCESS"

